import { mapActions } from "vuex";

export default  {
	methods: 
    {
		...mapActions({			
			saveAll: 'crudStore/saveAll',
		}),
		async actualizarFtn()
		{
			try{

			}catch{

			}
		},
		async saveForm(event)
		{
			try{
				if(event.ftn!==undefined)
				{
					switch(event.ftn)
					{
						case 'usuarioNuevoFtn':
							await this.updateDataPost({ 
								data: { 
									data: [],
									route: 'save_usuarios', 
									tablaPost: ['users']
								 }
							 }) 
						break;
						case 'inactivarFtn' :							
							await this.updateDataPost({ 
								data: { 
									data: [],
									route: 'inactive_usuarios', 
									tablaPost: ['users']
								 }
							 }) 
						break;

					}
				}
				await this.save(event.save)

				
				if(event.ftn!==undefined)
				{
					switch(event.ftn)
					{
						case 'lenteEditarFtn':
							if(this.indexData!==false)
							{
								await this.updateDataGet({ index: this.indexData, data: this.dataForm[this.namePath]})
							}
							else
							{
								let datos= {}
								datos.users = await this.gettersDatalist('users', this.dataForm[this.namePath].users.name)[0]
								await this.pushDataGet({ data: datos})
							}							
						break;
						case 'inactivarFtn':
							await this.spliceDataGet(this.indexData)
						break;

					}
				}
				this.resetGlobal({state: 'indexData'})
				this.resetGlobal({state: 'openModal'})
				this.resetDataForm()
			}
			catch{

			}			
		}		
	},
}
